import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppShell } from './AppShell';
import { pickArea } from './areaSwitch';
import { pickAdminNavigation } from '../workspaces/admin/adminNavigation';
import { selectHasPickupPoints, selectHasWmsAccess } from '../features/auth/authSelectors';

export const AdminLayout = () => {
  const { pathname } = useLocation();
  const hasWarehouse = useSelector(selectHasWmsAccess);
  const hasPickupPoints = useSelector(selectHasPickupPoints);
  const { navigation, inWarehouse } = pickAdminNavigation({ hasWarehouse, hasPickupPoints, pathname });
  const { areaLabel, areaSwitch } = pickArea({ hasWarehouse, inWarehouse });

  // Inside the warehouse module the menu is the module's; the sidebar names
  // the side it is on and offers the way across. The order upload is on both.
  return <AppShell navigation={navigation} areaLabel={areaLabel} areaSwitch={areaSwitch} />;
};
